<template>
  <div>
    <vs-card>
      <b-row align-h="start">
        <b-col cols="3" md="auto" style="padding-right: 2px; min-width: 200px">
          <b-form-datepicker
            id="start"
            v-model="startDate"
            size="md"
            :locale="locale"
            class="mb-2"
            today-variant="danger"
            placeholder="-"
            :start-weekday="weekday"
            :date-format-options="{
              year: 'numeric',
              month: 'numeric',
              day: 'numeric',
            }"
          />
        </b-col>
        <b-col cols="3" md="auto" style="padding-right: 2px; min-width: 200px">
          <b-form-datepicker
            id="end"
            v-model="endDate"
            size="md"
            :locale="locale"
            class="mb-2"
            today-variant="danger"
            placeholder="-"
            :start-weekday="weekday"
            :date-format-options="{
              year: 'numeric',
              month: 'numeric',
              day: 'numeric',
            }"
          />
        </b-col>
        <b-col cols="3" md="auto" style="padding-right: 2px">
          <b-button
            class="bg-primary"
            style="border-color: white"
            v-on:click="filterStockTrans()"
          >
            <Icon
              icon="ph:list-fill"
              style="margin-right: 5px"
              width="20"
              height="20"
            />{{ $t("List") }}
          </b-button>
        </b-col>
        <b-col lg="3" md="auto" style="padding-right: 2px">
          <b-button
            class="bg-primary"
            style="border-color: white"
            v-on:click="printStockForBarcode()"
          >
            <Icon
              icon="mdi:tag-outline"
              style="margin-right: 5px"
              width="20"
              height="20"
            />{{ $t("PrepareStockTicket") }}
          </b-button>
        </b-col>
      </b-row>
    </vs-card>
    <vs-card>
      <ag-grid-vue
        ref="agGridTable"
        class="scroll-to-ag-grid-table ag-theme-alpine w-100 my-4 ag-grid-table"
        :columnDefs="columns"
        :defaultColDef="defaultColDef"
        :rowData="processList"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :pagination="true"
        @grid-ready="onGridReady"
        :suppressCopyRowsToClipboard="true"
        :localeText="localeText"
        :suppressRowClickSelection="true"
        @first-data-rendered="onFirstDataRendered"
      >
      </ag-grid-vue>
    </vs-card>
    <BarcodePrintingPopup
      :isSidebarActive="isSidebarActiveLocal"
      :data="printData"
      @closeSidebar="printBarcode"
    />
  </div>
</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import { Icon } from "@iconify/vue2";
import i18nData from "../../i18n/i18nData";
import detailBtnCellRenderer from "../CellRenderers/detailBtnCellRenderer.vue";
import moment from "moment";
import transTypeCellRenderer from "./CellRenderers/transTypeCellRenderer.vue";
import BarcodePrintingPopup from "../stock/BarcodePrintingPopup.vue";
export default {
  data() {
    return {
      printData: "",
      locale: "de",
      weekday: 1,
      addNewInfoDataSidebar: false,
      isPromptActiveEmployeeLocal: false,
      addNewActSidebar: false,
      infoData: [],
      isSidebarActiveLocal: false,
      stockTransDetailClmn: [],
      endDate: "",
      startDate: "",
      processList: [],
      defaultColDef: {
        sortable: true,
        editable: true,
        resizable: true,
      },
      columns: [],
    };
  },
  components: {
    BarcodePrintingPopup,
    transTypeCellRenderer,
    detailBtnCellRenderer,
    AgGridVue,
    Icon,
  },

  methods: {
    printStockForBarcode() {
      window.open(
        this.$router.resolve({ name: "barcode-printing-modules" }).href,
        "_blank"
      );
    },
    parseDate(params) {
      return moment(String(params)).format("YYYY-MM-DD");
    },
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    getStockColumnList() {
      this.columns = [];
      if (this.processList.length > 0) {
        let columnList = Object.keys(this.processList[0]);
        this.columns.push({
          width: 100,
          pinned: "right",
          cellRendererFramework: "detailBtnCellRenderer",
          cellRendererParams: {
            detailMethods: "printBarcode",
            iconDetail: "material-symbols:print-outline",
            iconColor: "#065a82",
          },
        });

        columnList.forEach((val, index) => {
          if (val == "CompanyName" || val == "Barcode" || val == "Description") {
            this.columns.push({
              pinned: "left",
              headerName: this.$t(val),
              field: val,
              filter: "agSetColumnFilter",
            });
          } else if (val.toString().includes("Date") == true)
            this.columnsProcess.push({
              headerName: this.$t(val),
              field: val,
              filter: "agSetColumnFilter",
              valueFormatter: (params) => this.parseDate(params.data[val]),
              editable: true,
            });
          else if (
            val.toString().includes("Id") == false &&
            val.toString().includes("TrasnType") == false
          ) {
            this.columns.push({
              headerName: this.$t(val),
              field: val,
              filter: "agSetColumnFilter",
            });
          }
        });
      }
    },

    filterStockTrans() {
      const vs = this.$vs;
      this.startDate =
        this.startDate == ""
          ? this.parseDate(new Date(new Date().setDate(new Date().getDate() - 15)))
          : this.parseDate(this.startDate);
      this.endDate =
        this.endDate == ""
          ? this.parseDate(new Date(new Date().setDate(new Date().getDate() + 1)))
          : this.parseDate(this.endDate);
      let obj = {
        startDate: this.startDate,
        endDate: this.endDate,
      };
      this.$store
        .dispatch("stock/listStockTransAll", obj)
        .then((response) => {
          if (response.success == true) {
            try {
            } catch (error) {
              console.log(error);
            }
          } else
            vs.notify({
              text: response.data.message.toString(),
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
        })
        .catch((error) => {
          console.log(error);
          return new Promise((resolve, reject) => {
            resolve(false);
          });
        });
    },
    onGridReadyStTr(params) {
      this.gridApiStTr = params.api;
      this.gridColumnApiStTr = params.columnApi;
      var defaultSortModel = [{ colId: "CompanyName", sort: "asc", sortIndex: 0 }];
      params.columnApi.applyColumnState({ state: defaultSortModel });
      this.gridApiStTr.refreshCells(params);
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      var defaultSortModel = [{ colId: "CompanyName", sort: "asc", sortIndex: 0 }];
      params.columnApi.applyColumnState({ state: defaultSortModel });
      this.gridApi.refreshCells(params);
    },

    printBarcode(val = false) {
      this.isSidebarActiveLocal = val;
    },
  },
  computed: {
    stockAll: {
      get() {
        return this.$store.state.stock.StockItemsAll;
      },
      set(val) {
        if (!val) {
        }
      },
    },

    localeText() {
      return i18nData[this.$i18n.locale];
    },
  },
  mounted() {
    this.locale = this.$i18n.locale == "en" ? "en-US" : this.$i18n.locale;
    this.filterStockTrans();

    this.$root.$on("employeeDetail", (data) => {
      this.infoData = data;
      this.employeeDetail(data);
    });
    this.$root.$on("editStockTrans", (data) => {
      this.infoData = data;
      this.editStockTrans(data);
    });
    this.$root.$on("printBarcode", (data) => {
      console.log("inn");
      this.printData = data;
      this.printBarcode(true);
    });
  },
  beforeDestroy() {
    this.$root.$off("employeeDetail");
    this.$root.$off("editStockTrans");
    this.$root.$off("printBarcode");
  },
  watch: {
    stockAll(val) {
      if (val.length > 0) {
        this.processList = val;
        this.getStockColumnList();
      }
      return val;
    },
  },
};
</script>
<style lang="scss" scoped>
.scroll-to-ag-grid-table {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 190px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>
